// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_settingsMenuList__n6NPB {
    /* min-height: calc(100vh - 343px); */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 30px 0;
}

.page_settingsMenuList__n6NPB .page_pageSearchInput__nLsSe {
    width: 100%;
    margin-top: 0;
}

.page_settingsMenuList__n6NPB #page_pages_search__BgVNu {
    position: relative;
    right: 0;
}

.page_settingsListWrap__wJ3Fw {
    display: flex;
    margin-bottom: 30px;
}

.page_navLeftList__eyOZs {
    max-width: 370px;
    min-width: 370px;
}

.page_settingsMenuBlockTitle__l174g {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--cloudburst);
}

.page_titleBottom__H7tT6 {
    padding: 0 0 15px;
    margin-bottom: 0;
}

.page_navigationLeft__VeVqO {
    min-width: 280px;
    background: var(--white);
    border-width: 1px;
    border-style: solid;
    border-color: var(--ashyblue);
    border-radius: 6px;
}

.page_navigationBlocks__cVvOx {
    border-bottom: 1px solid var(--lightgrey);
    width: 100%;
    padding-top: 0px;
    padding-bottom: 0;
}

.page_navigationBlocks__cVvOx>div {
    overflow: hidden;
}

.page_navigationBlocks__cVvOx.page_linkAdd__QxHz6 .page_customLinkRow__inMCx .page_inputLink__vnZ3h {
    top: 42px;
}

.page_pagesTitle__zZqVO {
    padding-right: 18px;
    padding-left: 18px;
    padding: 1rem 1.5rem;
    position: relative;
    cursor: pointer;
    margin: 0;
}

.page_pagesTitle__zZqVO::before {
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: right;
    background-repeat: no-repeat;
    width: 12px;
    height: 18px;
    display: block;
    left: auto;
    position: absolute;
    right: 20px;
    top: 20px;
    transform: rotate(270deg);
    transition: 0.3s;
}

.page_pagesTitle__zZqVO.page_active__mol6C::before {
    transform: rotate(180deg);
}

.page_navigationTop__6Qd6o {
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 10px;
}

.page_navigationTop__6Qd6o #page_pages_search__BgVNu {
    width: 100%;
    padding-left: 40px;
}

.page_pageSearchInput__nLsSe {
    width: 400px;
    position: relative;
}

.page_pageSearchInput__nLsSe img.page_pageSearchIcon__tIfyL {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.page_pageSearchInput__nLsSe input {
    width: calc(100% - 5px);
    height: 42px !important;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 5px 5px 6px 40px;
    outline: none;
    right: 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.page_pageSearchInput__nLsSe input:not([type="checkbox"]) {
    height: 42px !important;
}

.page_pageSearchInput__nLsSe img {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

/* ---------- Location Page ---------- */
.page_locationPage__Cqxu3 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 30px;
    min-height: calc(100vh - 200px);
}

.page_pageHeader__kRrSI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.page_pageTitle__pJ5nE {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: var(--cloudburst);
    margin: 0;
}

.page_locationPage__Cqxu3 .page_searchWrapper__UjYR2 {
    max-width: 500px;
    border-top: 1px solid var(--lightgrey);
    padding-top: 30px;
    margin-top: 20px;
}

.page_searchWrapper__UjYR2 {
    max-width: 400px;
}

.page_searchInput__72YDe {
    position: relative;
    width: 100%;
}

.page_searchInput__72YDe input {
    width: 100%;
    height: 42px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 5px 5px 6px 40px;
    outline: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
    transition: border-color 0.2s ease;
}

.page_searchInput__72YDe input:focus {
    border-color: var(--cloudburst);
}

.page_searchInput__72YDe img {
    position: absolute;
    left: 15px;
    top: 14px;
    max-width: 14px;
    pointer-events: none;
}

.page_locationList__IrYmQ {
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-width: 500px;
}

.page_locationItem__0Vo\\+4 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 20px;
    border-bottom: 1px solid var(--lightgrey);
    transition: background-color 0.2s ease;
}

.page_locationItem__0Vo\\+4:last-child {
    border-bottom: none;
}

.page_locationItem__0Vo\\+4:hover {
    background-color: #f9fafb;
}

.page_locationName__n5hkI {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
}

.page_deleteBtn__7MGA1 {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.2s ease;
    opacity: 0.6;
}

.page_deleteBtn__7MGA1:hover {
    opacity: 1;
    background-color: #fee2e2;
}

.page_deleteBtn__7MGA1 img {
    width: 16px;
    height: 16px;
}

.page_emptyState__ndWsM {
    padding: 20px;
    text-align: center;
}

.page_emptyState__ndWsM .page_nothingFound__ndwT5 {
    margin-bottom: 0;
}

.page_nothingFound__ndwT5 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
    opacity: 0.6;
    margin: 0;
}

/* ---------- Location Settings ---------- */
.page_locationSettings__PMwny {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 20px;
    max-width: 500px;
}

.page_settingItem__SsRrm {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.page_settingLabel__Eyoeu {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
}

.page_toggleButton__bDFtB {
    width: 44px;
    height: 24px;
    background: var(--ashyblue);
    border: none;
    border-radius: 12px;
    cursor: pointer;
    padding: 0;
    position: relative;
    transition: background-color 0.2s ease;
    outline: none;
}

.page_toggleButton__bDFtB:focus-visible {
    box-shadow: 0 0 0 2px var(--cloudburst);
}

.page_toggleSlider__lsRB7 {
    display: block;
    width: 18px;
    height: 18px;
    background: var(--white);
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: transform 0.2s ease;
}

.page_toggleChecked__WR4e\\+ .page_toggleSlider__lsRB7 {
    transform: translateX(20px);
}

.page_toggleChecked__WR4e\\+ {
    background: #22c55e;
}

.page_zoneRegionsTextarea__pHNle {
    resize: vertical;
    width: 100%;
    min-height: 100px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 10px 14px;
    outline: none;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
    font-family: inherit;
}

.page_zoneRegionsTextarea__pHNle:focus {
    border-color: var(--cloudburst);
}

.page_zoneRegionsTextarea__pHNle::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grey);
}

.page_errorMessage__b\\+WEZ {
    color: #eb1e1e;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
}

/* Base Add Button (for CSS Modules) */
.page_addBtn__GparY {
    width: max-content;
    height: 40px;
    padding: 8px 16px;
    background: #000;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: var(--white);
    border: 0;
}

/* Responsive */
@media screen and (max-width: 768px) {
    .page_pageHeader__kRrSI {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
    }

    .page_searchWrapper__UjYR2 {
        max-width: 100%;
        width: 100%;
    }

    .page_locationPage__Cqxu3 {
        padding: 20px;
    }
}


.page_dropdownWrapper__1yJFi {
    position: relative;
}

.page_dropdownHeader__-tSNc {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: var(--cloudburst);
}

.page_dropdownHeader__-tSNc .page_title__CYf9X {
    flex: 1 1;
    margin-right: 8px;
}

.page_dropdownHeader__-tSNc .page_arrow__6Zz6Y {
    transition: transform 0.3s;
}

.page_dropdownHeader__-tSNc .page_arrow__6Zz6Y.page_rotate__IgMAI {
    transform: rotate(180deg);
}

.page_dropdownList__iHkbg {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    box-shadow: var(--boxshadow);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
}

.page_dropdownItem__YO8Vr {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: var(--cloudburst);
}

.page_dropdownItem__YO8Vr:hover {
    background: var(--lightgrey);
}

.page_customLinkRow__inMCx input::placeholder,
.page_menu-add-input__dtPcw::placeholder,
.page_pageSearchInput__nLsSe input::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grey);
}

.page_settingsMenuPages__qHNUD {
    padding-right: 24px;
    padding-left: 24px;
    overflow: hidden;
}

.page_settingsMenuItem__Y91Be input {
    background: var(--white);
    -o-appearance: none;
    appearance: none;
    outline: none;
    content: none;
    border: none !important;
    outline: none;
    cursor: pointer;
    width: 25px;
}

.page_settingsMenuItem__Y91Be {
    display: flex;
    cursor: pointer;
    margin-bottom: 10px;
}

.page_settingsMenuItem__Y91Be input {
    margin-top: 2px;
}

.page_settingsMenuItem__Y91Be p,
.page_settingsMenuItem__Y91Be label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    cursor: pointer;
}

.page_nothingFound__ndwT5 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    color: var(--cloudburst);
    margin-bottom: 10px;
}

.page_showMorePages__uNTen {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
    opacity: 0.5;
    cursor: pointer;
}

.page_customLinkRow__inMCx input,
.page_menuAddInput__X1yck {
    width: 100%;
    height: 40px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 10px 14px;
    outline: none;
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}



.page_menuAddInput__X1yck {
    max-width: 500px;
}

.page_linkInput__IguTi {
    padding-left: 33px !important;
}

.page_navigationBlocks__cVvOx.page_linkAdd__QxHz6 .page_customLinkRow__inMCx input {
    padding: 10px 14px 11px 14px;
}

.page_customLinkRow__inMCx p {
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--grayishblue);
}

.page_customLinkRow__inMCx {
    position: relative;
    margin-bottom: 20px;
    padding-left: 18px;
    padding-right: 18px;
}

.page_navigationBlocks__cVvOx.page_linkAdd__QxHz6 .page_customLinkRow__inMCx .page_inputLink__vnZ3h {
    top: 42px;
}

.page_navigationBlocks__cVvOx .page_addToMenu__1F7ov img {
    margin-right: 0;
    margin-left: 6px;
    max-width: 14px;
}

.page_inputLink__vnZ3h {
    position: absolute;
    left: 29px;
    top: 36px;
    width: 15px;
    height: 15px;
}

.page_addToMenu__1F7ov {
    padding: 8px 10px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    box-shadow: var(--boxshadow);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--cloudburst);
    margin-left: 18px;
    margin-bottom: 18px;
}

.page_addToMenu__1F7ov img {
    margin-right: 6px;
}

.page_addToMenu__1F7ov .page_addMenuText__KnD3- {
    color: var(--cloudburst);
}

.page_addToMenu__1F7ov p {
    font-weight: 500;
    color: var(--cloudburst);
    margin: 0;
}

.page_navigationRight__0G7F- {
    margin-left: 35px;
    padding-top: 0;
    min-width: 300px;
}

.page_navigationRight__0G7F- .page_navItem__9S\\+Yp {
    width: 380px;
}

.page_navRightList__R1KOD {
    margin-top: 15px;
}

.page_settingsMenuList__n6NPB .page_addBtn__GparY {
    width: max-content;
    height: 40px;
}

.page_settingsMenuList__n6NPB .page_addMenuContent__TOdYR .page_addBtn__GparY {
    margin-top: 10px;
}

.page_filterIcon__35QfE {
    font-size: 16px;
    opacity: 0.7;
}

.page_menuTop__6lDoG {
    display: flex;
    gap: 10px;
}

.page_navItem__9S\\+Yp {
    align-items: center;
    padding: 11.5px 14px;
    gap: 8px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    box-shadow: var(--boxshadow);
    border-radius: 6px;
    width: 100%;
    cursor: pointer;
    margin-bottom: 10px;
    font-size: 14px;
}

.page_navItem__9S\\+Yp .page_customLinkRow__inMCx {
    padding-left: 0;
    padding-right: 0;
    margin-top: 15px;
    margin-bottom: 5px;
}

.page_navItem__9S\\+Yp {
    width: 380px;
}

.page_navItem__9S\\+Yp .page_navLinkRow__0Fykb {
    margin-bottom: 10px;
}

.page_navItemLocked__8\\+KHu {
    cursor: default;
}

.page_navEditableVisible__zDNXv {
    display: flex;
    justify-content: space-between;
    -webkit-user-select: none;
            user-select: none;
}

.page_navEditableVisible__zDNXv>div {
    display: flex;
}

.page_navEditableVisible__zDNXv>div img {
    margin-right: 12px;
}

.page_navEditableVisible__zDNXv p {
    line-height: 18px;
    position: relative;
    top: 0px;
    margin: 0;
}

.page_navEditableVisible__zDNXv>div>img {
    cursor: grab;
}

.page_navEditableVisible__zDNXv .page_socialIcon__LSGPb {
    width: 18px;
}

.page_removeNavItem__G3cgg {
    border: 0;
    background: transparent;
    padding: 0 3px;
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--grayishblue);
    cursor: pointer;
}

.page_deleteRow__B7vjF {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.page_deleteRow__B7vjF p {
    margin-bottom: 0;
}

.page_deleteRow__B7vjF img {
    margin-right: 10px;
}

.page_nestableItemIsDragging__XiUP7:before {
    background: var(--whitesmoke) !important;
    border: 1px dashed #d0d5dd !important;
}
.page_appearanceMenuSection__Zz264 .page_appearanceMenuBox__u9peX {
    max-width: 1120px;
    padding: 25px 50px 50px 50px;
}

.page_appearanceMenuBox__u9peX .page_saveButton__aESXK.page_saveChangeButton__84NlK{
    width: 132.03px;
    height: 42px;
}
.page_appearanceMenuSection__Zz264 .page_appearanceMenuBlock__ZI0KY {
    display: flex;
    gap: 50px;
}

.page_appearanceMenuSection__Zz264 .page_appearanceMenuBlock__ZI0KY .page_appearanceMenuLeft__FWMNV {
    padding-right: 50px;
    border-right: 1px solid #d0d5dd;
}

.page_appearanceMenuSection__Zz264 .page_appearanceMenuBlock__ZI0KY .page_appearanceMenuLeft__FWMNV,
.page_appearanceMenuSection__Zz264 .page_appearanceMenuBlock__ZI0KY .page_appearanceMenuRight__fdmut {
    flex: 1 1;
}

.page_appearanceMenuWidgetBlock__DYvYp {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-block: 20px;
}

.page_appearanceMenuBoxLabel__D325K {
    font-weight: 500;
    font-size: 20px;
}

.page_appearanceMenuDescription__ds009 {
    margin: 0;
    font-size: 15px;
    line-height: 1.2;
}

.page_appearanceMenuWidgetBlock__DYvYp:not(:last-child) {
    border-bottom: 1px solid var(--lightgrey);
}

/* ---------- Title Input ---------- */
.page_footerTitleInput__X0taC {
    padding: 8px 12px;
    gap: 8px;
    height: 45px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
}

.page_footerLinkBlock__7ocDx {
    margin-top: 20px;
}

.page_footerLinkInputBlock__xQ8cn {
    display: flex;
    gap: 12px;
}

.page_footerLinkInputSection__KlZVP {
    margin-top: 10px;
    display: flex;
    gap: 12px;
    flex-direction: column;
}

.page_appearanceMenuTextArea__3vCdf {
    resize: vertical;
    width: 100%;
    min-height: 150px;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    padding: 8px 12px;
    outline: none;
    font-size: 14px;
}

.page_menuSorter__FIScq {
  position: relative;
}

.page_menuItemRow__703aJ {
    cursor: pointer;
}

.page_menuItemRow__703aJ,
.page_dragPreviewItem__7BJ7\\+ {
  border: 1px solid #d0d7de;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 10px;
  width: 380px;
  background: #fff;
}

.page_dragPreviewItem__7BJ7\\+ {
    display: flex;
    align-items: center;
    gap: 10px;
}

.page_menuItem__EFA1c {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
}

.page_menuItem__EFA1c,
.page_menuItem__EFA1c * {
  -webkit-user-select: none;
          user-select: none;
}

.page_hidden__Nc2sg {
  height: 0;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
}

.page_placeholder__dgTtN {
  height: 48px;
  margin-bottom: 8px;
  border: 2px dashed #c3c4c7;
  border-radius: 6px;
  background: #f6f7f7;
  width: 380px;
}

.page_dragPreview__UYUSf {
  position: absolute;
  right: 0; 
  left: auto;
  border-radius: 6px;
  pointer-events: none;
  z-index: 9999;
}

.page_dragIcon__t5Q8F {
  color: #6b7280;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.page_dropdownToggle__uWPFR {
    background: none;
    cursor: pointer;
    border: none;
    margin-left: auto;
}

.page_dropdownIcon__\\+6urt {
  transition: transform 0.25s ease;
}

.page_rotate__IgMAI {
  transform: rotate(180deg);
}

.page_menuItemText__4Ynxl {
    padding: 8px 12px;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d0d5dd;
    border-radius: 6px;
    outline: none;
    font-size: 12px;
}

.page_menuItemTextWrap__8wczX {
    margin: 8px 0 16px;
}

.page_menuTitleFront__zzGpY,
.page_menuItemTitle__pzCVo,
.page_dragPreviewItemTitle__C-UTi {
    font-size: 14px;
}

.page_menuItemTitle__pzCVo {
    margin-bottom: 8px;
}

.page_deleteMenuItem__bUtPp {
    background: none;
    border: none;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    padding: 0;
}
.page_customLinkWrapper__vpXRj {
    position: relative;
}
.page_customLinkWrapper__vpXRj .page_inputLink__vnZ3h {
    left: 13px;
    top: 13px;
}
.page_saveButtons__FU8Tz {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 25px;
    padding-top: 25px;
    border-top: 1px solid var(--lightgrey);
    gap: 0 15px;
}
body .page_saveButton__aESXK,
body .page_deleteButton__FJiCm {
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
    background-color: #000;
    border-color: transparent;
    padding: 8px 13px;
    text-align: center;
    width: auto;
    min-height: 42px;
}
.page_saveButtons__FU8Tz .page_saveButton__aESXK{
    width: 66px;
    height: 42px;
}
body .page_deleteButton__FJiCm {
    background-color: #eb1e1e;
    color: #fff;
    border: 1px solid #eb1e1e;
}

.page_whatsAppModulePreview__vDOyA {
    margin-top: 15px;
}

.page_whatsAppAccountItem__dWXrt {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    margin-bottom: 10px;
}

.page_whatsAppIconPreview__8SYXd {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #25D366;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
}

.page_whatsAppIconPreview__8SYXd img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.page_whatsAppAccountInfo__SE03Q {
    flex: 1 1;
}

.page_whatsAppAccountTitle__4ggA7 {
    font-weight: 600;
    font-size: 14px;
    color: var(--cloudburst);
}

.page_whatsAppAccountNumber__irqfg {
    font-size: 12px;
    color: var(--grey);
}

/* Media Queries */
@media screen and (max-width: 1260px) {
    .page_settingsListWrap__wJ3Fw .page_navLeftList__eyOZs {
        max-width: 100%;
        min-width: unset;
        margin-bottom: 20px;
    }

    .page_settingsListWrap__wJ3Fw {
        display: block;
    }

    .page_navLeftList__eyOZs .page_navigationLeft__VeVqO {
        min-width: auto;
        max-width: 100%;
    }
}

@media screen and (max-width: 600px) {
    .page_whatsAppAccountItem__dWXrt {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .page_whatsAppIconPreview__8SYXd {
        align-self: flex-start;
    }
}

@media screen and (max-width: 1100px) {
    .page_navigationRight__0G7F- .page_navItem__9S\\+Yp {
        width: 100%;
    }

    .page_footerLinkInputBlock__xQ8cn {
        flex-wrap: wrap;
    }
}

@media screen and (max-width: 1024px) {

    .page_navigationLeft__VeVqO,
    .page_navigationRight__0G7F- {
        max-width: 100%;
        min-width: 100%;
    }

    .page_navigationRight__0G7F- {
        margin-left: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
    }

    .page_navItem__9S\\+Yp {
        width: 100%;
    }

    .page_navEditableVisible__zDNXv>div {
        width: 80%;
    }
    .page_footerLinkInputBlock__xQ8cn {
        flex-wrap: nowrap;
    }
}

@media screen and (max-width: 980px) {
    .page_pageSearchInput__nLsSe input {
        right: 0px;
        width: calc(100% - 20px);
    }

    .page_pageSearchInput__nLsSe img {
        position: absolute;
        left: 15px;
        top: 13px;
    }
}

@media screen and (max-width: 840px) {
    .page_pageSearchInput__nLsSe input {
        right: 0px;
    }

    .page_pageSearchInput__nLsSe img {
        left: 15px;
    }

    .page_appearanceMenuSection__Zz264 .page_appearanceMenuBox__u9peX {
        padding: 22px;
    }

    .page_appearanceMenuSection__Zz264 .page_appearanceMenuBlock__ZI0KY {
        flex-direction: column;
        gap: 25px;
    }

    .page_appearanceMenuSection__Zz264 .page_appearanceMenuBlock__ZI0KY .page_appearanceMenuLeft__FWMNV {
        padding-right: 0;
        border: 0;
        padding-bottom: 25px;
        border-bottom: 1px solid #d0d5dd;
    }
}

@media screen and (max-width: 768px) {
    .page_pageSearchInput__nLsSe input {
        right: 0px;
    }

    .page_pageSearchInput__nLsSe img {
        left: 15px;
    }

    .page_footerLinkInputBlock__xQ8cn {
        flex-wrap: wrap;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Appearance/page.module.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,yDAAmD;IACnD,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA,wCAAwC;AACxC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,SAAS;AACb;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;AACjB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,sCAAsC;AACtC;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;;;IAGI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IAGxB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;AACzC;AACA;IACI,iBAAiB;IACjB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;;IAEI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,sCAAsC;AACtC;IACI,iBAAiB;IACjB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,UAAU;IACV,SAAS;AACb;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,sCAAsC;IACtC,WAAW;AACf;AACA;;IAEI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,oBAAoB;QACpB,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".settingsMenuList {\n    /* min-height: calc(100vh - 343px); */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 30px 30px 0;\n}\n\n.settingsMenuList .pageSearchInput {\n    width: 100%;\n    margin-top: 0;\n}\n\n.settingsMenuList #pages_search {\n    position: relative;\n    right: 0;\n}\n\n.settingsListWrap {\n    display: flex;\n    margin-bottom: 30px;\n}\n\n.navLeftList {\n    max-width: 370px;\n    min-width: 370px;\n}\n\n.settingsMenuBlockTitle {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--cloudburst);\n}\n\n.titleBottom {\n    padding: 0 0 15px;\n    margin-bottom: 0;\n}\n\n.navigationLeft {\n    min-width: 280px;\n    background: var(--white);\n    border-width: 1px;\n    border-style: solid;\n    border-color: var(--ashyblue);\n    border-radius: 6px;\n}\n\n.navigationBlocks {\n    border-bottom: 1px solid var(--lightgrey);\n    width: 100%;\n    padding-top: 0px;\n    padding-bottom: 0;\n}\n\n.navigationBlocks>div {\n    overflow: hidden;\n}\n\n.navigationBlocks.linkAdd .customLinkRow .inputLink {\n    top: 42px;\n}\n\n.pagesTitle {\n    padding-right: 18px;\n    padding-left: 18px;\n    padding: 1rem 1.5rem;\n    position: relative;\n    cursor: pointer;\n    margin: 0;\n}\n\n.pagesTitle::before {\n    content: \"\";\n    background-image: url(../../assets/images/down.svg);\n    background-position: right;\n    background-repeat: no-repeat;\n    width: 12px;\n    height: 18px;\n    display: block;\n    left: auto;\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    transform: rotate(270deg);\n    transition: 0.3s;\n}\n\n.pagesTitle.active::before {\n    transform: rotate(180deg);\n}\n\n.navigationTop {\n    padding-left: 18px;\n    padding-right: 18px;\n    padding-bottom: 10px;\n}\n\n.navigationTop #pages_search {\n    width: 100%;\n    padding-left: 40px;\n}\n\n.pageSearchInput {\n    width: 400px;\n    position: relative;\n}\n\n.pageSearchInput img.pageSearchIcon {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.pageSearchInput input {\n    width: calc(100% - 5px);\n    height: 42px !important;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 5px 5px 6px 40px;\n    outline: none;\n    right: 15px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.pageSearchInput input:not([type=\"checkbox\"]) {\n    height: 42px !important;\n}\n\n.pageSearchInput img {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n/* ---------- Location Page ---------- */\n.locationPage {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding: 30px;\n    min-height: calc(100vh - 200px);\n}\n\n.pageHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.pageTitle {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--cloudburst);\n    margin: 0;\n}\n\n.locationPage .searchWrapper {\n    max-width: 500px;\n    border-top: 1px solid var(--lightgrey);\n    padding-top: 30px;\n    margin-top: 20px;\n}\n\n.searchWrapper {\n    max-width: 400px;\n}\n\n.searchInput {\n    position: relative;\n    width: 100%;\n}\n\n.searchInput input {\n    width: 100%;\n    height: 42px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 5px 5px 6px 40px;\n    outline: none;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n    transition: border-color 0.2s ease;\n}\n\n.searchInput input:focus {\n    border-color: var(--cloudburst);\n}\n\n.searchInput img {\n    position: absolute;\n    left: 15px;\n    top: 14px;\n    max-width: 14px;\n    pointer-events: none;\n}\n\n.locationList {\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    max-width: 500px;\n}\n\n.locationItem {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px 20px;\n    border-bottom: 1px solid var(--lightgrey);\n    transition: background-color 0.2s ease;\n}\n\n.locationItem:last-child {\n    border-bottom: none;\n}\n\n.locationItem:hover {\n    background-color: #f9fafb;\n}\n\n.locationName {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n}\n\n.deleteBtn {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    opacity: 0.6;\n}\n\n.deleteBtn:hover {\n    opacity: 1;\n    background-color: #fee2e2;\n}\n\n.deleteBtn img {\n    width: 16px;\n    height: 16px;\n}\n\n.emptyState {\n    padding: 20px;\n    text-align: center;\n}\n\n.emptyState .nothingFound {\n    margin-bottom: 0;\n}\n\n.nothingFound {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n    opacity: 0.6;\n    margin: 0;\n}\n\n/* ---------- Location Settings ---------- */\n.locationSettings {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 20px;\n    max-width: 500px;\n}\n\n.settingItem {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.settingLabel {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n}\n\n.toggleButton {\n    width: 44px;\n    height: 24px;\n    background: var(--ashyblue);\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    padding: 0;\n    position: relative;\n    transition: background-color 0.2s ease;\n    outline: none;\n}\n\n.toggleButton:focus-visible {\n    box-shadow: 0 0 0 2px var(--cloudburst);\n}\n\n.toggleSlider {\n    display: block;\n    width: 18px;\n    height: 18px;\n    background: var(--white);\n    border-radius: 50%;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    transition: transform 0.2s ease;\n}\n\n.toggleChecked .toggleSlider {\n    transform: translateX(20px);\n}\n\n.toggleChecked {\n    background: #22c55e;\n}\n\n.zoneRegionsTextarea {\n    resize: vertical;\n    width: 100%;\n    min-height: 100px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 10px 14px;\n    outline: none;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n    font-family: inherit;\n}\n\n.zoneRegionsTextarea:focus {\n    border-color: var(--cloudburst);\n}\n\n.zoneRegionsTextarea::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grey);\n}\n\n.errorMessage {\n    color: #eb1e1e;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n}\n\n/* Base Add Button (for CSS Modules) */\n.addBtn {\n    width: max-content;\n    height: 40px;\n    padding: 8px 16px;\n    background: #000;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--white);\n    border: 0;\n}\n\n/* Responsive */\n@media screen and (max-width: 768px) {\n    .pageHeader {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 15px;\n    }\n\n    .searchWrapper {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .locationPage {\n        padding: 20px;\n    }\n}\n\n\n.dropdownWrapper {\n    position: relative;\n}\n\n.dropdownHeader {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    color: var(--cloudburst);\n}\n\n.dropdownHeader .title {\n    flex: 1;\n    margin-right: 8px;\n}\n\n.dropdownHeader .arrow {\n    transition: transform 0.3s;\n}\n\n.dropdownHeader .arrow.rotate {\n    transform: rotate(180deg);\n}\n\n.dropdownList {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    box-shadow: var(--boxshadow);\n    z-index: 1000;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.dropdownItem {\n    padding: 8px 12px;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--cloudburst);\n}\n\n.dropdownItem:hover {\n    background: var(--lightgrey);\n}\n\n.customLinkRow input::placeholder,\n.menu-add-input::placeholder,\n.pageSearchInput input::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grey);\n}\n\n.settingsMenuPages {\n    padding-right: 24px;\n    padding-left: 24px;\n    overflow: hidden;\n}\n\n.settingsMenuItem input {\n    background: var(--white);\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    outline: none;\n    content: none;\n    border: none !important;\n    outline: none;\n    cursor: pointer;\n    width: 25px;\n}\n\n.settingsMenuItem {\n    display: flex;\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n.settingsMenuItem input {\n    margin-top: 2px;\n}\n\n.settingsMenuItem p,\n.settingsMenuItem label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    cursor: pointer;\n}\n\n.nothingFound {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: left;\n    color: var(--cloudburst);\n    margin-bottom: 10px;\n}\n\n.showMorePages {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n    opacity: 0.5;\n    cursor: pointer;\n}\n\n.customLinkRow input,\n.menuAddInput {\n    width: 100%;\n    height: 40px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 10px 14px;\n    outline: none;\n    position: relative;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n\n\n.menuAddInput {\n    max-width: 500px;\n}\n\n.linkInput {\n    padding-left: 33px !important;\n}\n\n.navigationBlocks.linkAdd .customLinkRow input {\n    padding: 10px 14px 11px 14px;\n}\n\n.customLinkRow p {\n    margin-bottom: 10px;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--grayishblue);\n}\n\n.customLinkRow {\n    position: relative;\n    margin-bottom: 20px;\n    padding-left: 18px;\n    padding-right: 18px;\n}\n\n.navigationBlocks.linkAdd .customLinkRow .inputLink {\n    top: 42px;\n}\n\n.navigationBlocks .addToMenu img {\n    margin-right: 0;\n    margin-left: 6px;\n    max-width: 14px;\n}\n\n.inputLink {\n    position: absolute;\n    left: 29px;\n    top: 36px;\n    width: 15px;\n    height: 15px;\n}\n\n.addToMenu {\n    padding: 8px 10px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    box-shadow: var(--boxshadow);\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--cloudburst);\n    margin-left: 18px;\n    margin-bottom: 18px;\n}\n\n.addToMenu img {\n    margin-right: 6px;\n}\n\n.addToMenu .addMenuText {\n    color: var(--cloudburst);\n}\n\n.addToMenu p {\n    font-weight: 500;\n    color: var(--cloudburst);\n    margin: 0;\n}\n\n.navigationRight {\n    margin-left: 35px;\n    padding-top: 0;\n    min-width: 300px;\n}\n\n.navigationRight .navItem {\n    width: 380px;\n}\n\n.navRightList {\n    margin-top: 15px;\n}\n\n.settingsMenuList .addBtn {\n    width: max-content;\n    height: 40px;\n}\n\n.settingsMenuList .addMenuContent .addBtn {\n    margin-top: 10px;\n}\n\n.filterIcon {\n    font-size: 16px;\n    opacity: 0.7;\n}\n\n.menuTop {\n    display: flex;\n    gap: 10px;\n}\n\n.navItem {\n    align-items: center;\n    padding: 11.5px 14px;\n    gap: 8px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    box-shadow: var(--boxshadow);\n    border-radius: 6px;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 10px;\n    font-size: 14px;\n}\n\n.navItem .customLinkRow {\n    padding-left: 0;\n    padding-right: 0;\n    margin-top: 15px;\n    margin-bottom: 5px;\n}\n\n.navItem {\n    width: 380px;\n}\n\n.navItem .navLinkRow {\n    margin-bottom: 10px;\n}\n\n.navItemLocked {\n    cursor: default;\n}\n\n.navEditableVisible {\n    display: flex;\n    justify-content: space-between;\n    user-select: none;\n}\n\n.navEditableVisible>div {\n    display: flex;\n}\n\n.navEditableVisible>div img {\n    margin-right: 12px;\n}\n\n.navEditableVisible p {\n    line-height: 18px;\n    position: relative;\n    top: 0px;\n    margin: 0;\n}\n\n.navEditableVisible>div>img {\n    cursor: grab;\n}\n\n.navEditableVisible .socialIcon {\n    width: 18px;\n}\n\n.removeNavItem {\n    border: 0;\n    background: transparent;\n    padding: 0 3px;\n    display: flex;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--grayishblue);\n    cursor: pointer;\n}\n\n.deleteRow {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.deleteRow p {\n    margin-bottom: 0;\n}\n\n.deleteRow img {\n    margin-right: 10px;\n}\n\n.nestableItemIsDragging:before {\n    background: var(--whitesmoke) !important;\n    border: 1px dashed #d0d5dd !important;\n}\n.appearanceMenuSection .appearanceMenuBox {\n    max-width: 1120px;\n    padding: 25px 50px 50px 50px;\n}\n\n.appearanceMenuBox .saveButton.saveChangeButton{\n    width: 132.03px;\n    height: 42px;\n}\n.appearanceMenuSection .appearanceMenuBlock {\n    display: flex;\n    gap: 50px;\n}\n\n.appearanceMenuSection .appearanceMenuBlock .appearanceMenuLeft {\n    padding-right: 50px;\n    border-right: 1px solid #d0d5dd;\n}\n\n.appearanceMenuSection .appearanceMenuBlock .appearanceMenuLeft,\n.appearanceMenuSection .appearanceMenuBlock .appearanceMenuRight {\n    flex: 1;\n}\n\n.appearanceMenuWidgetBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding-block: 20px;\n}\n\n.appearanceMenuBoxLabel {\n    font-weight: 500;\n    font-size: 20px;\n}\n\n.appearanceMenuDescription {\n    margin: 0;\n    font-size: 15px;\n    line-height: 1.2;\n}\n\n.appearanceMenuWidgetBlock:not(:last-child) {\n    border-bottom: 1px solid var(--lightgrey);\n}\n\n/* ---------- Title Input ---------- */\n.footerTitleInput {\n    padding: 8px 12px;\n    gap: 8px;\n    height: 45px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    font-size: 14px;\n}\n\n.footerLinkBlock {\n    margin-top: 20px;\n}\n\n.footerLinkInputBlock {\n    display: flex;\n    gap: 12px;\n}\n\n.footerLinkInputSection {\n    margin-top: 10px;\n    display: flex;\n    gap: 12px;\n    flex-direction: column;\n}\n\n.appearanceMenuTextArea {\n    resize: vertical;\n    width: 100%;\n    min-height: 150px;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    padding: 8px 12px;\n    outline: none;\n    font-size: 14px;\n}\n\n.menuSorter {\n  position: relative;\n}\n\n.menuItemRow {\n    cursor: pointer;\n}\n\n.menuItemRow,\n.dragPreviewItem {\n  border: 1px solid #d0d7de;\n  border-radius: 6px;\n  padding: 16px;\n  margin-bottom: 10px;\n  width: 380px;\n  background: #fff;\n}\n\n.dragPreviewItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.menuItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n}\n\n.menuItem,\n.menuItem * {\n  user-select: none;\n}\n\n.hidden {\n  height: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n}\n\n.placeholder {\n  height: 48px;\n  margin-bottom: 8px;\n  border: 2px dashed #c3c4c7;\n  border-radius: 6px;\n  background: #f6f7f7;\n  width: 380px;\n}\n\n.dragPreview {\n  position: absolute;\n  right: 0; \n  left: auto;\n  border-radius: 6px;\n  pointer-events: none;\n  z-index: 9999;\n}\n\n.dragIcon {\n  color: #6b7280;\n  cursor: grab;\n  user-select: none;\n}\n\n.dropdownToggle {\n    background: none;\n    cursor: pointer;\n    border: none;\n    margin-left: auto;\n}\n\n.dropdownIcon {\n  transition: transform 0.25s ease;\n}\n\n.rotate {\n  transform: rotate(180deg);\n}\n\n.menuItemText {\n    padding: 8px 12px;\n    width: 100%;\n    background: #ffffff;\n    border: 1px solid #d0d5dd;\n    border-radius: 6px;\n    outline: none;\n    font-size: 12px;\n}\n\n.menuItemTextWrap {\n    margin: 8px 0 16px;\n}\n\n.menuTitleFront,\n.menuItemTitle,\n.dragPreviewItemTitle {\n    font-size: 14px;\n}\n\n.menuItemTitle {\n    margin-bottom: 8px;\n}\n\n.deleteMenuItem {\n    background: none;\n    border: none;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    padding: 0;\n}\n.customLinkWrapper {\n    position: relative;\n}\n.customLinkWrapper .inputLink {\n    left: 13px;\n    top: 13px;\n}\n.saveButtons {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n    margin-top: 25px;\n    padding-top: 25px;\n    border-top: 1px solid var(--lightgrey);\n    gap: 0 15px;\n}\nbody .saveButton,\nbody .deleteButton {\n    display: inline-block;\n    font-size: 14px;\n    font-weight: 500;\n    color: #fff;\n    line-height: 22px;\n    border-radius: 6px;\n    cursor: pointer;\n    white-space: nowrap;\n    background-color: #000;\n    border-color: transparent;\n    padding: 8px 13px;\n    text-align: center;\n    width: auto;\n    min-height: 42px;\n}\n.saveButtons .saveButton{\n    width: 66px;\n    height: 42px;\n}\nbody .deleteButton {\n    background-color: #eb1e1e;\n    color: #fff;\n    border: 1px solid #eb1e1e;\n}\n\n.whatsAppModulePreview {\n    margin-top: 15px;\n}\n\n.whatsAppAccountItem {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    margin-bottom: 10px;\n}\n\n.whatsAppIconPreview {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #25D366;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 20px;\n}\n\n.whatsAppIconPreview img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.whatsAppAccountInfo {\n    flex: 1;\n}\n\n.whatsAppAccountTitle {\n    font-weight: 600;\n    font-size: 14px;\n    color: var(--cloudburst);\n}\n\n.whatsAppAccountNumber {\n    font-size: 12px;\n    color: var(--grey);\n}\n\n/* Media Queries */\n@media screen and (max-width: 1260px) {\n    .settingsListWrap .navLeftList {\n        max-width: 100%;\n        min-width: unset;\n        margin-bottom: 20px;\n    }\n\n    .settingsListWrap {\n        display: block;\n    }\n\n    .navLeftList .navigationLeft {\n        min-width: auto;\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .whatsAppAccountItem {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .whatsAppIconPreview {\n        align-self: flex-start;\n    }\n}\n\n@media screen and (max-width: 1100px) {\n    .navigationRight .navItem {\n        width: 100%;\n    }\n\n    .footerLinkInputBlock {\n        flex-wrap: wrap;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n\n    .navigationLeft,\n    .navigationRight {\n        max-width: 100%;\n        min-width: 100%;\n    }\n\n    .navigationRight {\n        margin-left: 0px;\n        padding-left: 0px;\n        padding-bottom: 20px;\n    }\n\n    .navItem {\n        width: 100%;\n    }\n\n    .navEditableVisible>div {\n        width: 80%;\n    }\n    .footerLinkInputBlock {\n        flex-wrap: nowrap;\n    }\n}\n\n@media screen and (max-width: 980px) {\n    .pageSearchInput input {\n        right: 0px;\n        width: calc(100% - 20px);\n    }\n\n    .pageSearchInput img {\n        position: absolute;\n        left: 15px;\n        top: 13px;\n    }\n}\n\n@media screen and (max-width: 840px) {\n    .pageSearchInput input {\n        right: 0px;\n    }\n\n    .pageSearchInput img {\n        left: 15px;\n    }\n\n    .appearanceMenuSection .appearanceMenuBox {\n        padding: 22px;\n    }\n\n    .appearanceMenuSection .appearanceMenuBlock {\n        flex-direction: column;\n        gap: 25px;\n    }\n\n    .appearanceMenuSection .appearanceMenuBlock .appearanceMenuLeft {\n        padding-right: 0;\n        border: 0;\n        padding-bottom: 25px;\n        border-bottom: 1px solid #d0d5dd;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .pageSearchInput input {\n        right: 0px;\n    }\n\n    .pageSearchInput img {\n        left: 15px;\n    }\n\n    .footerLinkInputBlock {\n        flex-wrap: wrap;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsMenuList": `page_settingsMenuList__n6NPB`,
	"pageSearchInput": `page_pageSearchInput__nLsSe`,
	"pages_search": `page_pages_search__BgVNu`,
	"settingsListWrap": `page_settingsListWrap__wJ3Fw`,
	"navLeftList": `page_navLeftList__eyOZs`,
	"settingsMenuBlockTitle": `page_settingsMenuBlockTitle__l174g`,
	"titleBottom": `page_titleBottom__H7tT6`,
	"navigationLeft": `page_navigationLeft__VeVqO`,
	"navigationBlocks": `page_navigationBlocks__cVvOx`,
	"linkAdd": `page_linkAdd__QxHz6`,
	"customLinkRow": `page_customLinkRow__inMCx`,
	"inputLink": `page_inputLink__vnZ3h`,
	"pagesTitle": `page_pagesTitle__zZqVO`,
	"active": `page_active__mol6C`,
	"navigationTop": `page_navigationTop__6Qd6o`,
	"pageSearchIcon": `page_pageSearchIcon__tIfyL`,
	"locationPage": `page_locationPage__Cqxu3`,
	"pageHeader": `page_pageHeader__kRrSI`,
	"pageTitle": `page_pageTitle__pJ5nE`,
	"searchWrapper": `page_searchWrapper__UjYR2`,
	"searchInput": `page_searchInput__72YDe`,
	"locationList": `page_locationList__IrYmQ`,
	"locationItem": `page_locationItem__0Vo+4`,
	"locationName": `page_locationName__n5hkI`,
	"deleteBtn": `page_deleteBtn__7MGA1`,
	"emptyState": `page_emptyState__ndWsM`,
	"nothingFound": `page_nothingFound__ndwT5`,
	"locationSettings": `page_locationSettings__PMwny`,
	"settingItem": `page_settingItem__SsRrm`,
	"settingLabel": `page_settingLabel__Eyoeu`,
	"toggleButton": `page_toggleButton__bDFtB`,
	"toggleSlider": `page_toggleSlider__lsRB7`,
	"toggleChecked": `page_toggleChecked__WR4e+`,
	"zoneRegionsTextarea": `page_zoneRegionsTextarea__pHNle`,
	"errorMessage": `page_errorMessage__b+WEZ`,
	"addBtn": `page_addBtn__GparY`,
	"dropdownWrapper": `page_dropdownWrapper__1yJFi`,
	"dropdownHeader": `page_dropdownHeader__-tSNc`,
	"title": `page_title__CYf9X`,
	"arrow": `page_arrow__6Zz6Y`,
	"rotate": `page_rotate__IgMAI`,
	"dropdownList": `page_dropdownList__iHkbg`,
	"dropdownItem": `page_dropdownItem__YO8Vr`,
	"menu-add-input": `page_menu-add-input__dtPcw`,
	"settingsMenuPages": `page_settingsMenuPages__qHNUD`,
	"settingsMenuItem": `page_settingsMenuItem__Y91Be`,
	"showMorePages": `page_showMorePages__uNTen`,
	"menuAddInput": `page_menuAddInput__X1yck`,
	"linkInput": `page_linkInput__IguTi`,
	"addToMenu": `page_addToMenu__1F7ov`,
	"addMenuText": `page_addMenuText__KnD3-`,
	"navigationRight": `page_navigationRight__0G7F-`,
	"navItem": `page_navItem__9S+Yp`,
	"navRightList": `page_navRightList__R1KOD`,
	"addMenuContent": `page_addMenuContent__TOdYR`,
	"filterIcon": `page_filterIcon__35QfE`,
	"menuTop": `page_menuTop__6lDoG`,
	"navLinkRow": `page_navLinkRow__0Fykb`,
	"navItemLocked": `page_navItemLocked__8+KHu`,
	"navEditableVisible": `page_navEditableVisible__zDNXv`,
	"socialIcon": `page_socialIcon__LSGPb`,
	"removeNavItem": `page_removeNavItem__G3cgg`,
	"deleteRow": `page_deleteRow__B7vjF`,
	"nestableItemIsDragging": `page_nestableItemIsDragging__XiUP7`,
	"appearanceMenuSection": `page_appearanceMenuSection__Zz264`,
	"appearanceMenuBox": `page_appearanceMenuBox__u9peX`,
	"saveButton": `page_saveButton__aESXK`,
	"saveChangeButton": `page_saveChangeButton__84NlK`,
	"appearanceMenuBlock": `page_appearanceMenuBlock__ZI0KY`,
	"appearanceMenuLeft": `page_appearanceMenuLeft__FWMNV`,
	"appearanceMenuRight": `page_appearanceMenuRight__fdmut`,
	"appearanceMenuWidgetBlock": `page_appearanceMenuWidgetBlock__DYvYp`,
	"appearanceMenuBoxLabel": `page_appearanceMenuBoxLabel__D325K`,
	"appearanceMenuDescription": `page_appearanceMenuDescription__ds009`,
	"footerTitleInput": `page_footerTitleInput__X0taC`,
	"footerLinkBlock": `page_footerLinkBlock__7ocDx`,
	"footerLinkInputBlock": `page_footerLinkInputBlock__xQ8cn`,
	"footerLinkInputSection": `page_footerLinkInputSection__KlZVP`,
	"appearanceMenuTextArea": `page_appearanceMenuTextArea__3vCdf`,
	"menuSorter": `page_menuSorter__FIScq`,
	"menuItemRow": `page_menuItemRow__703aJ`,
	"dragPreviewItem": `page_dragPreviewItem__7BJ7+`,
	"menuItem": `page_menuItem__EFA1c`,
	"hidden": `page_hidden__Nc2sg`,
	"placeholder": `page_placeholder__dgTtN`,
	"dragPreview": `page_dragPreview__UYUSf`,
	"dragIcon": `page_dragIcon__t5Q8F`,
	"dropdownToggle": `page_dropdownToggle__uWPFR`,
	"dropdownIcon": `page_dropdownIcon__+6urt`,
	"menuItemText": `page_menuItemText__4Ynxl`,
	"menuItemTextWrap": `page_menuItemTextWrap__8wczX`,
	"menuTitleFront": `page_menuTitleFront__zzGpY`,
	"menuItemTitle": `page_menuItemTitle__pzCVo`,
	"dragPreviewItemTitle": `page_dragPreviewItemTitle__C-UTi`,
	"deleteMenuItem": `page_deleteMenuItem__bUtPp`,
	"customLinkWrapper": `page_customLinkWrapper__vpXRj`,
	"saveButtons": `page_saveButtons__FU8Tz`,
	"deleteButton": `page_deleteButton__FJiCm`,
	"whatsAppModulePreview": `page_whatsAppModulePreview__vDOyA`,
	"whatsAppAccountItem": `page_whatsAppAccountItem__dWXrt`,
	"whatsAppIconPreview": `page_whatsAppIconPreview__8SYXd`,
	"whatsAppAccountInfo": `page_whatsAppAccountInfo__SE03Q`,
	"whatsAppAccountTitle": `page_whatsAppAccountTitle__4ggA7`,
	"whatsAppAccountNumber": `page_whatsAppAccountNumber__irqfg`
};
export default ___CSS_LOADER_EXPORT___;
